//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _cloneDeep from 'lodash/cloneDeep';
import configStore from '@/store/modules/configStore';
import agreeShelfDataMixin from '@/components/upload/dialogs/agreeShelfDataMixin';

export default {
    mixins: [agreeShelfDataMixin],
    props: {
        entity: {
            type: Object,
            required: true,
        },
        entityKind: {
            type: String,
            default: 'File',
            validator: (value) => ['File', 'EnquiryAttachment'].indexOf(value) !== -1,
        },
        customer: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            entityModel: _cloneDeep(this.entity),
            customerModel: _cloneDeep(this.customer),
            updateStatus: true,
        };
    },
    computed: {
        headline() {
            let entity = 'Dokument';
            if (this.entityKind === 'EnquiryAttachment') {
                entity = 'Bankdokument';
            }

            return `${entity} archivieren`;
        },
        ...configStore.mapState({
            config: configStore.STATE.CONFIG,
        }),
    },
    mounted() {
        this.initShelfData(
            this.entity.agree21ShelfId && this.entity.agree21Comment
                ? `${this.entity.agree21ShelfId}-${this.entity.agree21Comment}`
                : null
        );
    },
    methods: {
        onShelfDataUpdate(id, comment) {
            this.entityModel.agree21ShelfId = id;
            this.entityModel.agree21Comment = comment;
        },
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        async ok() {
            const isValid = await this.$refs.form.validate(true);
            if (!isValid) {
                return;
            }

            this.$emit('ok', {
                entity: {
                    ...this.entityModel,
                    updateStatus: this.updateStatus,
                },
                customer: this.customerModel,
            });
            this.hide();
        },
        cancel() {
            this.hide();
        },
    },
};
